import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { CartLineContext } from "@insite/client-framework/Components/CartLineContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddAllToList, getCurrentCartState, hasProductsWithInvalidPrice } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
// import removeCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { CardListStyles } from "@insite/content-library/Components/CardList";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
// import CartLineCardCondensed, {
//     CartLineCardCondensedStyles,
// } from "@insite/content-library/Widgets/Cart/CartLineCardCondensed";
// import CartLineCardExpanded, {
//     CartLineCardExpandedStyles,
// } from "@insite/content-library/Widgets/Cart/CartLineCardExpanded";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import CartLineRollService from "@tSurya/Components/CartLineRollService";
import removeCartLine from "@tSurya/Handlers/Cart/RemoveCartLineExtended";
import CartLineCardCondensed, { CartLineCardCondensedStyles } from "@tSurya/Overrides/Widgets/Cart/CartLineCardCondensed";
import CartLineCardExpanded, { CartLineCardExpandedStyles } from "@tSurya/Overrides/Widgets/Cart/CartLineCardExpanded";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import * as cssLinter from "css";
import React, { FC, useContext, useState, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import clearCurrentCart from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";

const enum fields {
    showLineNotes = "showLineNotes",
    showImage = "showImage",
    showProductTitle = "showProductTitle",
    showBrand = "showBrand",
    showAddAllToList = "showAddAllToList",
    showPerUnitPrice = "showPerUnitPrice",
    showPriceLabel = "showPriceLabel",
    showAddToList = "showAddToList",
    showItemCount = "showItemCount",
    showProductNumber = "showProductNumber",
    showBackToTop = "showBackToTop",
    showVmiBinDetails = "showVmiBinDetails",
    customCSS = "customCSS",
}

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const defaultCustomCss = `.main-grid-container{
}

.title-grid-item{
}

.title{
}

.description-grid-item{
}

.description-text{
}

.email-grid-item{
}

.email-text-field{
}

.email-button{
}

.disclaimer-grid-item{
}

.disclaimer-text{
}`;

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showLineNotes]: boolean;
        [fields.showImage]: boolean;
        [fields.showProductTitle]: boolean;
        [fields.showBrand]: boolean;
        [fields.showAddAllToList]: boolean;
        [fields.showPerUnitPrice]: boolean;
        [fields.showPriceLabel]: boolean;
        [fields.showAddToList]: boolean;
        [fields.showItemCount]: boolean;
        [fields.showProductNumber]: boolean;
        [fields.showBackToTop]: boolean;
        [fields.showVmiBinDetails]: boolean;
        [fields.customCSS]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
    promotionsDataView: getCurrentPromotionsDataView(state),
    settingsCollection: getSettingsCollection(state),
    session: getSession(state),
    isUpdatingCartLine: state.pages.cart.isUpdatingCartLine,
    isUpdatingCart: state.context.isUpdatingCart,
    isLoading: state.data.carts.isLoading,
    isRemovingCartLine: Object.getOwnPropertyNames(state.pages.cart.isRemovingCartLine).length > 0,
    showPricing: state.context.showPricing,
    showInventory: state.context.showInventory,
});

const mapDispatchToProps = {
    updateCartLine,
    removeCartLine,
    setAddToListModalIsOpen,
    addToWishList,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CartLinesStyles {
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noCartLinesText?: TypographyProps;
    noCartLinesIcon?: IconPresentationProps;
    headerWrapper?: InjectableCss;
    header?: CartLinesHeaderStyles;
    cardList?: CardListStyles;
    cardContainer?: CardContainerStyles;
    cardExpanded?: CartLineCardExpandedStyles;
    cardCondensed?: CartLineCardCondensedStyles;
    footerWrapper?: InjectableCss;
    backToTopButton?: ButtonPresentationProps;
    addToListWrapper?: InjectableCss;
    modalContainer?: ModalPresentationProps;
    closeButton?: ButtonPresentationProps;
    mainContainer?: GridContainerProps;
}

interface CartLinesHeaderStyles {
    itemCountText?: TypographyProps;
    condensedViewCheckboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    condensedViewCheckbox?: CheckboxPresentationProps;
    overflowMenu?: OverflowMenuPresentationProps;
    addAllToListLink?: LinkPresentationProps;
    mainSection?: InjectableCss;
    columnHeadersSection?: InjectableCss;
    columnHeadersContainer?: InjectableCss;
    productHeader?: TypographyProps;
    unitPriceHeader?: TypographyProps;
    qtyHeader?: TypographyProps;
    totalPriceHeader?: TypographyProps;
    warningIcon?: IconPresentationProps;
    warningSection?: InjectableCss;
    warningText?: InjectableCss;
}

export const cartLinesStyles: CartLinesStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    noCartLinesText: {
        variant: "h3",
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: ${TYPOGRAPHY.size.largest};
            line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-style: normal;
        `,
    },
    noCartLinesIcon: {
        src: ShoppingCart,
        size: 45,
        color: "text.link",
        css: css`
            margin-bottom: 20px;
        `,
    },
    headerWrapper: {
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 10px;
            margin-top: 16px;
        `,
    },
    header: {
        condensedViewCheckboxGroup: {
            css: css`
                margin-left: auto;
            `,
        },
        condensedViewCheckbox: {
            typographyProps: {
                css: css`
                    margin-left: 10px;
                `,
            },
        },
        overflowMenu: {
            cssOverrides: {
                wrapper: css`
                    margin-left: 20px;
                `,
            },
        },
        addAllToListLink: {
            css: css`
                margin-left: 24px;
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-size: ${TYPOGRAPHY.size.base};
                font-weight: ${TYPOGRAPHY.weight.mediumbold};

                span {
                    font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                    font-size: ${TYPOGRAPHY.size.base};
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                }
            `,
        },
        mainSection: {
            css: css`
                display: flex;
                align-items: center;
                padding-bottom: 5px;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-top: 16px;
                            `,
                        ],
                        "max",
                    )}
            `,
        },
        columnHeadersSection: {
            css: css`
                width: 100%;
                padding: 10px 0;
                margin-top: 10px;
            `,
        },
        columnHeadersContainer: {
            css: css`
                display: grid;
                grid-template-columns: 115px minmax(280px, 340px) 1fr 1fr 1fr 24px;
                gap: 20px;
                width: 100%;
                padding: 0 10px;
                align-items: center;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                grid-template-columns: 70px 270px 1fr 1fr 1fr 21px;
                                gap: 12px;
                            `,
                            css`
                                grid-template-columns: 70px 270px 1fr 1fr 1fr 21px;
                                gap: 12px;
                            `,
                            null,
                        ],
                        "minMax",
                    )}
            `,
        },
        productHeader: {
            variant: "h6",
            weight: 600,
            css: css`
                color: ${COLORS.primary.base};
                margin: 0;
            `,
        },
        unitPriceHeader: {
            variant: "h6",
            weight: 600,
            css: css`
                color: ${COLORS.primary.base};
                margin: 0;
                text-align: center;
            `,
        },
        qtyHeader: {
            variant: "h6",
            weight: 600,
            css: css`
                color: ${COLORS.primary.base};
                margin: 0;
                text-align: center;
            `,
        },
        totalPriceHeader: {
            variant: "h6",
            weight: 600,
            css: css`
                color: ${COLORS.primary.base};
                margin: 0;
                text-align: right;
            `,
        },
        warningIcon: {
            src: "AlertCircle",
            color: "danger.main",
            css: css`
                margin-right: 10px;
            `,
        },
        warningSection: {
            css: css`
                display: flex;
                align-items: center;
                border: 2px solid ${getColor("danger.main")};
                padding: 15px 10px;
            `,
        },
        warningText: {
            css: css`
                color: ${getColor("danger.main")};
                margin: 0;
            `,
        },
        itemCountText: {
            css: css`
                color: #545454;
            `,
        },
    },
    footerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    backToTopButton: {
        variant: "secondary",
        css: css`
            margin: 16px 0;
            font-family: ${TYPOGRAPHY.button.fontFamily};
            font-weight: ${TYPOGRAPHY.button.weight};
            font-size: ${TYPOGRAPHY.button.size};
            line-height: 1.5;
            color: ${COLORS.primary.base};
            border: 1px solid ${COLORS.primary.base} !important;
            background-color: transparent !important;

            &:hover:not(:disabled) {
                color: ${COLORS.darkmagenta} !important;
                border-color: ${COLORS.darkmagenta} !important;
                background-color: transparent !important;
            }

            &:hover:not(:disabled) span {
                color: ${COLORS.darkmagenta} !important;
            }
        `,
    },
    addToListWrapper: {
        css: css`
            [class^="StyledButton"] {
                font-weight: ${TYPOGRAPHY.weight.mediumbold} !important;
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                color: #a45d44 !important;

                [class^="TypographyStyle"] {
                    font-weight: ${TYPOGRAPHY.weight.mediumbold} !important;
                    font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                    color: #a45d44 !important;
                }
            }
        `,
    },
    modalContainer: {
        size: 550,
        cssOverrides: {
            modalTitle: css`
                border: 0px;
                padding: 10px 20px;
                background-color: #f8f8f8;
            `,
            modalContent: css`
                padding: 20px;
            `,
            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 95%;
                            height: auto;
                        `,
                        css`
                            width: 75%;
                            height: auto;
                        `,
                        css`
                            width: 75%;
                            height: auto;
                        `,
                        null,
                        null,
                    ])}
            `,
            titleButton: css`
                border-radius: 4px !important;
                padding: 0px !important;
                border: 1px solid black !important;
                min-height: 0px !important;
            `,
        },
    },
    closeButton: {
        buttonType: "outline",
        css: css`
            margin-right: 10px;
            span[class^="TypographyStyle"] {
                color: black;
                font-size: 14px;
            }
        `,
    },
    mainContainer: {
        css: css`
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            padding: 20px;
            padding-bottom: 0px;
            width: 100%;
        `,
    },
};

const StyledSection = getStyledWrapper("section");

const styles = cartLinesStyles;

const CartLines: FC<Props> = ({
    cart,
    promotionsDataView,
    settingsCollection,
    session,
    fields,
    isUpdatingCartLine,
    isUpdatingCart,
    isLoading,
    updateCartLine,
    removeCartLine,
    isRemovingCartLine,
    showPricing,
    showInventory,
    setAddToListModalIsOpen,
    addToWishList,
}) => {
    const [isCondensed, setIsCondensed] = useState(false);
    const [isRemoveAllModalOpen, setIsRemoveAllModalOpen] = useState(false);
    const toasterContext = useContext(ToasterContext);

    const [isStandaloneRugPadModalOpen, setIsStandaloneRugPadModalOpen] = useState(false);
    const [removedRugPads, setRemovedRugPads] = useState<string[]>([]);
    const addAllToListClickHandler = () => {
        const productInfos =
            cart?.cartLines
                ?.filter(o => o.productId && o.qtyOrdered)
                .map(cartLine => ({
                    productId: cartLine.productId!,
                    qtyOrdered: cartLine.qtyOrdered!,
                    unitOfMeasure: cartLine.unitOfMeasure,
                    properties: { ...(cartLine.properties || {}) },
                })) || [];
        if (!settingsCollection.wishListSettings?.allowMultipleWishLists) {
            addToWishList({
                productInfos,
                onSuccess: () => {
                    toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                },
                onComplete(resultProps) {
                    if (resultProps.result?.wishList) {
                        // "this" is targeting the object being created, not the parent SFC

                        this.onSuccess?.(resultProps.result.wishList);
                    } else if (resultProps.result?.errorMessage) {
                        toasterContext.addToast({ body: resultProps.result.errorMessage, messageType: "danger" });
                    }
                },
            });
            return;
        }

        setAddToListModalIsOpen({ modalIsOpen: true, productInfos });
    };

    // The page-level CartPage overlay already covers cart updates. Avoid replacing the cart
    // contents with a second, lighter CartLines spinner while that overlay is active.
    useEffect(() => {
        if (!cart?.cartLines?.length) {
            return;
        }
        if (isRemovingCartLine) {
            return;
        }

        const cartLineIdsToRemove: string[] = [];
        const removedRugPadNames: string[] = [];

        cart.cartLines.forEach(product => {
            const linkedCode = product.properties.linkedRugItemCode;

            if (product.properties.isRollpadService === "true" && linkedCode) {
                const matchingProduct = cart.cartLines?.find(x => x.productName === linkedCode);

                if (!matchingProduct) {
                    removedRugPadNames.push(product.productName);
                    cartLineIdsToRemove.push(product.id);
                }
            }
        });

        if (cartLineIdsToRemove.length > 0) {
            setRemovedRugPads(prev => Array.from(new Set([...prev, ...removedRugPadNames])));
            removeCartLine({ cartLineIds: cartLineIdsToRemove });
            setIsStandaloneRugPadModalOpen(true);
        }
    }, [cart, isRemovingCartLine, removeCartLine]);

    if (isStandaloneRugPadModalOpen) {
        return (
            <Modal
                {...styles.modalContainer}
                headline="Rollpad Service"
                isOpen={isStandaloneRugPadModalOpen}
                handleClose={() => setIsStandaloneRugPadModalOpen(false)}
                sizeVariant="small"
            >
                <Typography>The following standalone rug pad(s) were removed: {removedRugPads.join(", ")}</Typography>

                <StyledWrapper {...styles.mainContainer}>
                    <Button onClick={() => setIsStandaloneRugPadModalOpen(false)}>OK</Button>
                </StyledWrapper>
            </Modal>
        );
    }

    if (!cart || (!isUpdatingCart && ((cart.lineCount && !cart.cartLines) || isLoading[cart.id]))) {
        return (
            <StyledSection {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledSection>
        );
    }

    const cartLines = cart.cartLines || [];
    if (cartLines.length === 0) {
        return (
            <StyledSection {...styles.centeringWrapper}>
                <Icon {...styles.noCartLinesIcon} />
                <Typography {...styles.noCartLinesText} data-test-selector="cart_noCartLinesMessage">
                    {siteMessage("Cart_NoOrderLines")}
                </Typography>
            </StyledSection>
        );
    }

    const isCondensedChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setIsCondensed(value);
    };

    const removeAllClickHandler = () => {
        if (cart.status === "AwaitingApproval") {
            setIsRemoveAllModalOpen(true);
        } else {
            clearCurrentCart();
        }
    };

    const submitRemoveAllClickHandler = () => {
        setIsRemoveAllModalOpen(false);
        clearCurrentCart();
    };

    const { productSettings } = settingsCollection;
    const { value: promotions } = promotionsDataView;
    const productsCannotBePurchased = cartLines.some(o => o.isRestricted || !o.isActive || o.cantBuy);
    const isLoadingCart = isLoading[cart.id];

    const rollpadServiceCount = cartLines
        .filter(cartLine => cartLine.properties.isRollpadService === "true")
        .reduce((sum, cartLine) => sum + (cartLine.qtyOrdered ?? 0), 0);

    const renderCartLine = (cartLine: (typeof cartLines)[number]) => {
        const matchingPromotions = promotions ? promotions.filter(promo => promo.orderLineId === cartLine.id) : [];
        const showRemoveAction = !cartLine.isPromotionItem && cart.canModifyOrder;
        return (
            <CartLineContext.Provider value={cartLine} key={cartLine.id}>
                {isCondensed ? (
                    <CartLineCardCondensed
                        cart={cart}
                        promotions={matchingPromotions}
                        productSettings={productSettings}
                        showInventoryAvailability={showInventory}
                        extendedStyles={styles.cardCondensed}
                        updateCartLine={updateCartLine}
                        removeCartLine={removeCartLine}
                        showRemoveAction={showRemoveAction}
                        showVmiBinDetails={fields.showVmiBinDetails}
                    />
                ) : (
                    <>
                        <CartLineCardExpanded
                            cart={cart}
                            promotions={matchingPromotions}
                            productSettings={productSettings}
                            showInventoryAvailability={showInventory}
                            showLineNotes={fields.showLineNotes}
                            showImage={fields.showImage}
                            showProductTitle={fields.showProductTitle}
                            showBrand={fields.showBrand}
                            showPerUnitPrice={fields.showPerUnitPrice}
                            showPriceLabel={fields.showPriceLabel}
                            showAddToList={fields.showAddToList}
                            showProductNumber={fields.showProductNumber}
                            extendedStyles={styles.cardExpanded}
                            updateCartLine={updateCartLine}
                            removeCartLine={removeCartLine}
                            showRemoveAction={showRemoveAction}
                            showVmiBinDetails={fields.showVmiBinDetails}
                        />
                    </>
                )}
            </CartLineContext.Provider>
        );
    };

    const cartLinesDisplay = cartLines.map(cartLine => {
        if (!showPricing && cartLine.isPromotionItem) {
            return null;
        }
        return renderCartLine(cartLine);
    });

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };

    return (
        <StyledWrapper {...customCssWrapper}>
            <StyledSection {...styles.wrapper}>
                <LoadingOverlay {...styles.loadingOverlay} loading={false}>
                    <CartLinesHeader
                        totalItemCount={cartLines.length}
                        isCondensed={isCondensed}
                        productsCannotBePurchased={productsCannotBePurchased}
                        cartNotPriced={cart.cartNotPriced}
                        hasInsufficientInventory={cart.hasInsufficientInventory}
                        hasInvalidPrice={hasProductsWithInvalidPrice(cart)}
                        failedToGetRealTimeInventory={cart.failedToGetRealTimeInventory}
                        onIsCondensedChange={isCondensedChangeHandler}
                        onAddAllToListClick={addAllToListClickHandler}
                        canAddAllToList={canAddAllToList(cart)}
                        showItemCount={fields.showItemCount}
                        showAddAllToList={fields.showAddAllToList}
                        fulfillmentMethod={cart.fulfillmentMethod}
                    />
                    {cartLinesDisplay}
                    {rollpadServiceCount > 0 && <CartLineRollService count={rollpadServiceCount} />}
                    {fields.showBackToTop !== false && <CartLinesFooter />}
                    <TwoButtonModal
                        headlineText={translate("Are you sure?")}
                        modalIsOpen={isRemoveAllModalOpen}
                        messageText={siteMessage("OrderApproval_RemoveAllConfirmationMessage")}
                        cancelButtonText={translate("Cancel")}
                        submitButtonText={translate("Clear cart and delete order")}
                        onCancel={() => setIsRemoveAllModalOpen(false)}
                        onSubmit={submitRemoveAllClickHandler}
                    ></TwoButtonModal>
                </LoadingOverlay>
            </StyledSection>
        </StyledWrapper>
    );
};

interface CartLinesHeaderProps {
    totalItemCount: number;
    isCondensed: boolean;
    productsCannotBePurchased?: boolean;
    cartNotPriced?: boolean;
    hasInsufficientInventory?: boolean;
    hasInvalidPrice?: boolean;
    failedToGetRealTimeInventory?: boolean;
    onIsCondensedChange: CheckboxProps["onChange"];
    onAddAllToListClick: () => void;
    canAddAllToList?: boolean;
    showItemCount?: boolean;
    showAddAllToList?: boolean;
    fulfillmentMethod?: string;
}

const CartLinesHeader: FC<CartLinesHeaderProps> = ({
    totalItemCount,
    isCondensed,
    productsCannotBePurchased,
    cartNotPriced,
    hasInsufficientInventory,
    hasInvalidPrice,
    failedToGetRealTimeInventory,
    onIsCondensedChange,
    onAddAllToListClick,
    canAddAllToList = true,
    showItemCount = true,
    showAddAllToList = true,
    fulfillmentMethod,
}) => {
    const headerStyles = styles.header || {};

    return (
        <StyledSection {...styles.headerWrapper} id="cartHeader">
            <StyledSection {...headerStyles.mainSection}>
                {showItemCount && <Typography {...headerStyles.itemCountText}>{`${totalItemCount} ${translate("Items")}`}</Typography>}
                <CheckboxGroup {...headerStyles.condensedViewCheckboxGroup}>
                    <Checkbox
                        checked={isCondensed}
                        onChange={onIsCondensedChange}
                        data-test-selector="cartlineHeader_condensedCheckbox"
                        {...headerStyles.condensedViewCheckbox}
                    >
                        {translate("Condensed View")}
                        <VisuallyHidden>{translate("for product list")}</VisuallyHidden>
                    </Checkbox>
                </CheckboxGroup>
                {showAddAllToList && (
                    <Hidden above="md" {...styles.addToListWrapper}>
                        <Clickable
                            onClick={onAddAllToListClick}
                            disabled={!canAddAllToList}
                            data-test-selector="cartlineHeader_addAllToList"
                            css={headerStyles.addAllToListLink?.css}
                        >
                            {translate("Add All to List")}
                        </Clickable>
                    </Hidden>
                )}
                {showAddAllToList && (
                    <Hidden below="lg" {...styles.addToListWrapper}>
                        <Link onClick={onAddAllToListClick} {...headerStyles.addAllToListLink} data-test-selector="cartlineHeader_addAllToList">
                            {translate("Add All to List")}
                        </Link>
                    </Hidden>
                )}
            </StyledSection>
            {!isCondensed && (
                <Hidden below="md">
                    <StyledSection
                        css={css`
                            width: 100%;
                            padding: 10px 0;
                            border-bottom: 1px solid ${getColor("common.border")};
                            margin-top: 10px;
                        `}
                    >
                        <StyledSection
                            css={css`
                                display: grid;
                                grid-template-columns: 115px minmax(280px, 340px) 1fr 1fr 1fr 24px;
                                gap: 20px;
                                width: 100%;
                                padding: 10px 0;
                                align-items: center;

                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(
                                        theme,
                                        [
                                            null,
                                            css`
                                                grid-template-columns: 62px minmax(280px, 340px) 1fr 1fr 1fr 24px;
                                                gap: 12px;
                                            `,
                                            css`
                                                grid-template-columns: 70px 270px 1fr 1fr 1fr 10px;
                                                gap: 12px;
                                            `,
                                            null,
                                            null,
                                        ],
                                        "minMax",
                                    )}
                            `}
                        >
                            <Typography
                                variant="h6"
                                weight={600}
                                css={css`
                                    font-family: ${TYPOGRAPHY.fontFamily.title};
                                    font-style: normal;
                                    font-weight: ${TYPOGRAPHY.weight.baseBold};
                                    font-size: ${TYPOGRAPHY.size.base};
                                    line-height: ${TYPOGRAPHY.lineHeight.xbase};
                                    color: ${COLORS.text.main};
                                    margin: 0;
                                `}
                            >
                                {translate("Product")}
                            </Typography>
                            <span></span>
                            <Typography
                                variant="h6"
                                weight={600}
                                css={css`
                                    font-family: ${TYPOGRAPHY.fontFamily.title};
                                    font-style: normal;
                                    font-weight: ${TYPOGRAPHY.weight.baseBold};
                                    font-size: ${TYPOGRAPHY.size.base};
                                    line-height: ${TYPOGRAPHY.lineHeight.xbase};
                                    color: ${COLORS.text.main};
                                    margin: 0;
                                    text-align: left;
                                `}
                            >
                                {translate("Unit Price")}
                            </Typography>
                            <Typography
                                variant="h6"
                                weight={600}
                                css={css`
                                    font-family: ${TYPOGRAPHY.fontFamily.title};
                                    font-style: normal;
                                    font-weight: ${TYPOGRAPHY.weight.baseBold};
                                    font-size: ${TYPOGRAPHY.size.base};
                                    line-height: ${TYPOGRAPHY.lineHeight.xbase};
                                    color: ${COLORS.text.main};
                                    margin: 0;
                                    text-align: center;
                                `}
                            >
                                Qty
                            </Typography>
                            <Typography
                                variant="h6"
                                weight={600}
                                css={css`
                                    font-family: ${TYPOGRAPHY.fontFamily.title};
                                    font-style: normal;
                                    font-weight: ${TYPOGRAPHY.weight.baseBold};
                                    font-size: ${TYPOGRAPHY.size.base};
                                    line-height: ${TYPOGRAPHY.lineHeight.xbase};
                                    color: ${COLORS.text.main};
                                    margin: 0;
                                    text-align: center;
                                `}
                            >
                                {translate("Total Price")}
                            </Typography>
                            <div></div>
                        </StyledSection>
                    </StyledSection>
                </Hidden>
            )}
            {productsCannotBePurchased && (
                <StyledSection {...headerStyles.warningSection}>
                    <Icon {...headerStyles.warningIcon}></Icon>
                    <Typography {...headerStyles.warningText} data-test-selector="cartlineHeader_warningProductsCannotBePurchased">
                        {siteMessage("Cart_ProductsCannotBePurchased")}
                    </Typography>
                </StyledSection>
            )}
            {cartNotPriced && (
                <StyledSection {...headerStyles.warningSection}>
                    <Icon {...headerStyles.warningIcon}></Icon>
                    <Typography {...headerStyles.warningText} data-test-selector="cartlineHeader_NoPriceAvailableAtCheckout">
                        {siteMessage("Cart_NoPriceAvailableAtCheckout")}
                    </Typography>
                </StyledSection>
            )}
            {hasInsufficientInventory && fulfillmentMethod === "Ship" && (
                <StyledSection {...headerStyles.warningSection}>
                    <Icon {...headerStyles.warningIcon}></Icon>
                    <Typography {...headerStyles.warningText} data-test-selector="cartlineHeader_warningInsufficientInventoryAtCheckout">
                        {siteMessage("Cart_InsufficientInventoryAtCheckout")}
                    </Typography>
                </StyledSection>
            )}
            {hasInsufficientInventory && fulfillmentMethod === "PickUp" && (
                <StyledSection {...headerStyles.warningSection}>
                    <Icon {...headerStyles.warningIcon}></Icon>
                    <Typography {...headerStyles.warningText} data-test-selector="cartlineHeader_warningInsufficientPickupInventory">
                        {siteMessage("Cart_InsufficientPickupInventory")}
                    </Typography>
                </StyledSection>
            )}
            {!cartNotPriced && hasInvalidPrice && (
                <StyledSection {...headerStyles.warningSection}>
                    <Icon {...headerStyles.warningIcon}></Icon>
                    <Typography {...headerStyles.warningText}>{siteMessage("Cart_InvalidPriceAtCheckout")}</Typography>
                </StyledSection>
            )}
            {failedToGetRealTimeInventory && (
                <StyledSection {...headerStyles.warningSection}>
                    <Icon {...headerStyles.warningIcon}></Icon>
                    <Typography {...headerStyles.warningText}>{siteMessage("Cart_NoInventoryAvailableAtCheckout")}</Typography>
                </StyledSection>
            )}
        </StyledSection>
    );
};

const CartLinesFooter: FC = () => {
    const backToTopClickHandler = () => {
        const header = document.getElementById("cartHeader");
        if (header) {
            window.scrollTo(0, header.offsetTop);
        }
    };

    return (
        <StyledSection {...styles.footerWrapper}>
            <Button onClick={backToTopClickHandler} {...styles.backToTopButton}>
                {translate("Back to Top")}
            </Button>
        </StyledSection>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CartLines),
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        fieldDefinitions: [
            {
                name: fields.showLineNotes,
                displayName: "Show Line Notes",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                isRequired: false,
                variant: "toggle",
                tooltip: "This setting does not apply to Punchout orders, which will never display Line Notes.",
                tab: basicTab,
                sortOrder: 0,
            },
            {
                name: fields.showImage,
                displayName: "Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 1,
            },
            {
                name: fields.showProductTitle,
                displayName: "Product title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 2,
            },
            {
                name: fields.showBrand,
                displayName: "Brand",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 3,
            },
            {
                name: fields.showAddAllToList,
                displayName: "Add All to List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 4,
            },
            {
                name: fields.showPerUnitPrice,
                displayName: "Per unit price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 5,
            },
            {
                name: fields.showPriceLabel,
                displayName: "Price label",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 6,
            },
            {
                name: fields.showAddToList,
                displayName: "Add to list",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 7,
            },
            {
                name: fields.showItemCount,
                displayName: "Item count",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 8,
            },
            {
                name: fields.showProductNumber,
                displayName: "Product number",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 9,
            },
            {
                name: fields.showBackToTop,
                displayName: "Back to top",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 10,
            },
            {
                name: fields.showVmiBinDetails,
                displayName: "VMI Bin details",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                isEnabled: () => true,
                fieldType: "General",
                tab: basicTab,
                sortOrder: 11,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
